---
title: "Sending a Package"
slug: sending-a-package
description: "Step-by-step guide for scanning and sending a package to an internal or external destination."
keywords:
  - send
  - package
  - scan
  - GRAI
  - destination
  - recipient
  - shipment
---

## Prerequisites

- Role: Scanner, Manager, or Company Admin
- At least one internal location must be assigned to your account
- The package must carry a valid GRAI identifier

## Steps

1. Navigate to **Send** in the top menu.
2. Select your current location from the **Current Location** dropdown.
3. Scan the QR code on the package using the camera, or enter the GRAI manually via **Enter Package ID**.
4. Select the recipient:
   - **Next internal location** — choose one of your internal locations from the dropdown.
   - **External destination** — select an existing external destination from the list or create a new one.
   - **Shopify order** — search for an order to link the shipment to a Shopify order. Leave empty if the shipment has no Shopify order.
5. Optionally fill in the **Order ID (optional)** field with your internal reference.
6. Add any notes under **Description (optional)**, such as condition or special requests.
7. Click **Send Package** to confirm the shipment.
8. The shipment appears immediately under **Recent Activity** in the scanner area.

## If something goes wrong

- **"Package not found"** — The GRAI may not be registered yet. Use the **Register as new package** function to create it.
- **"You are not authorized to send from this location"** — Your assigned role does not allow sending from this location. Contact your Company Admin.
- **"Package already in transit since ..."** — The package is still in active transit. Ask the receiving location to mark it as received first.
- **Network error on send** — The shipment was not saved. Check your internet connection and try again.
- Contact us: support@heycircle.com or use the feedback button in the bottom-right corner of the screen.

## Related Articles

- [Receiving a Package](/app/help?article=scanning-a-package)
- [Reporting a Defect](/app/help?article=reporting-a-defect)
- [Initial Setup](/app/help?article=initial-setup)
